import {get as _get, find as _find, random as _random} from 'lodash';

import initialState from '../initialstate';
import {
	GET_GA_TASKS,
	CREATE_GA_TASK,
	EDIT_GA_TASK,
	DELETE_GA_TASK,
	SET_LATEST_PUBLISH,
	UPDATE_DOCUMENT_NAME_ON_TASKS,
	DELETE_DOCUMENT_ON_TASKS
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeInstructions, {sortAll} from '../GAInstructions/normalizeInstructions';
import {
	normalizeCreateInstruction,
	normalizeDeleteInstruction,
	normalizeEditInstruction
} from '../GAInstructions/normalizeInstructionActions';
import {normalizeDeleteDocument, normalizeRenameDocument} from '../GAInstructions/normalizeDocumentActions';

export default function GATasksReducer(state = initialState.gaTasks, action) {
	switch (action.type) {
		case GET_GA_TASKS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', {});
				return normalizeInstructions(data, true);
			}
			return state;
		}
		case CREATE_GA_TASK: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Created) {
				const task = _get(action, 'response.instructions[0]', null);
				return sortAll(normalizeCreateInstruction({state, instruction: task, isTask: true}), true);
			}
			return state;
		}
		case EDIT_GA_TASK: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const task = _get(action, 'response', null);
				return sortAll(normalizeEditInstruction({state, instruction: task, isTask: true}), true);
			}
			return state;
		}
		case DELETE_GA_TASK: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.NoContent) {
				const instructionId = _get(action, 'instructionId', null);
				return normalizeDeleteInstruction({state, instructionId, isTask: true});
			}
			return state;
		}
		case SET_LATEST_PUBLISH: {
			if (state) {
				return {
					...state,
					lastPublishDate: new Date().toISOString()
				};
			}
			return state;
		}
		case UPDATE_DOCUMENT_NAME_ON_TASKS: {
			if (state) {
				return normalizeRenameDocument(state, action.payload);
			}
			return state;
		}
		case DELETE_DOCUMENT_ON_TASKS: {
			if (state) {
				return normalizeDeleteDocument(state, action.payload);
			}
			return state;
		}
		default:
			return state;
	}
}
